<ion-header no-border>
  <ion-toolbar>

    <ion-title class="text-center color-dark" data-cy="editLinks-form-formTitle" *ngIf="showFormTitle === true">
      {{inputLabel}}
  
      <ion-icon 
        *ngIf="inputData.type === 'vCard'" 
        color="primary" 
        tappable 
        ios="information-circle-sharp"
        md="information-circle-sharp"
        (click)="checkVCard()"
      />
    </ion-title>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="editLinks-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="primary" data-cy="editLinks-form-formTitle" *ngIf="showTitleOnTop === true">
      {{inputLabel}}
      <ion-icon *ngIf="inputData.type === 'vCard'" color="primary" tappable ios="information-circle-sharp"
        md="information-circle-sharp" (click)="checkVCard()">
      </ion-icon>
    </ion-title>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary"
        [disabled]="inputData.title.trim() === '' && inputData.URL.trim() === ''" (click)="done()"
        data-cy="editLinks-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="app-edit-links padding">
  <ion-label class="editFieldLabel" *ngIf="showTitle === true" data-cy="editLinks-form-title-lbl">Title</ion-label>
  <ion-item lines="none" *ngIf="showTitle === true">
    <ion-input mode="ios" autocapitalize="words" lines="none" #titleInputId id="titleInputId" [(ngModel)]="inputData.title"
      data-cy="editLinks-form-title-input"></ion-input>
  </ion-item>

  <div *ngIf="showTitle === true" class="spacer-15"></div>

  <div *ngIf="inputData.type !== 'vCard' && inputLabel !== 'Edit Listing Link'">
    <ion-label *ngIf="showTitle === true || showURL" class="editFieldLabel" data-cy="editLinks-form-url-lbl">URL</ion-label>
    <ion-item lines="none">
      <ion-input mode="ios" [disabled]="inputData.type === 'vCard'" lines="none" type="url" #urlInputId id="urlInputId"
        [(ngModel)]="inputData.URL" data-cy="editLinks-form-lbl-input">
      </ion-input>
    </ion-item>
  </div>

  <div *ngIf="inputLabel === 'Edit Listing Link'">
    <ion-label class="editFieldLabel" data-cy="editLinks-form-address-lbl">Address</ion-label>
    <ion-item lines="none">
      <ion-input mode="ios" [disabled]="inputLabel === 'Edit Listing Link'" lines="none" type="url" #urlInputId id="urlInputId"
        [(ngModel)]="inputData.title" data-cy="editLinks-form-lbl-input">
      </ion-input>
    </ion-item>
  </div>

  <ng-container *ngIf="showAnimationSection">
    <div class="spacer-15"></div>
    <ion-label class="editFieldLabel" data-cy="editLinks-form-animation-lbl">Animation</ion-label>
    <ion-row class="animation-options-row">
      <div class="animation-col">
        <div [ngClass]="inputData.animation === '' ? 'selected-bg' : 'unselected-bg'" class="animation-container"
          (click)="setAnimationType('')" data-cy="editLinks-form-animation-none">
          <ion-icon *ngIf="inputData.animation === ''" mode="ios" name="checkmark-circle"></ion-icon>
          <img [src]="inputData.animation === '' ? '/assets/imgs/none-active.svg' : '/assets/imgs/none-inactive.svg'" />
          <span class="standardLabel">None</span>
        </div>
      </div>
      <div class="animation-col">
        <div [ngClass]="inputData.animation === 'shake' ? 'selected-bg' : 'unselected-bg'" class="animation-container"
          (click)="setAnimationType('shake')" data-cy="editLinks-form-animation-shake">
          <ion-icon *ngIf="inputData.animation === 'shake'" mode="ios" name="checkmark-circle"></ion-icon>
          <img
            [src]="inputData.animation === 'shake' ? '/assets/imgs/shake-active.svg' : '/assets/imgs/shake-inactive.svg'" />
          <span class="standardLabel">Shake</span>
        </div>
      </div>
      <div class="animation-col">
        <div [ngClass]="inputData.animation === 'sheen' ? 'selected-bg' : 'unselected-bg'" class="animation-container"
          (click)="setAnimationType('sheen')" data-cy="editLinks-form-animation-sheen">
          <ion-icon *ngIf="inputData.animation === 'sheen'" mode="ios" name="checkmark-circle"></ion-icon>
          <img
            [src]="inputData.animation === 'sheen' ? '/assets/imgs/sheen-active.svg' : '/assets/imgs/sheen-inactive.svg'" />
          <span class="standardLabel">Sheen</span>
        </div>
      </div>
    </ion-row>
  </ng-container>

  <ng-container *ngIf="showTypeSection">
    <div class="spacer-15"></div>
    <ion-label class="editFieldLabel" data-cy="editLinks-form-type-lbl">Landing Page</ion-label>
    <ion-row class="animation-options-row">
      <div class="animation-col">
        <div
          [ngClass]="(inputData.landingPage === 'listing-microsite' || inputData.landingPage === undefined) ? 'selected-bg' : 'unselected-bg'"
          class="animation-container" (click)="setLandingPage('listing-microsite')" data-cy="editLinks-form-type-none">
          <ion-icon *ngIf="inputData.landingPage === 'listing-microsite' || inputData.landingPage === undefined"
            mode="ios" name="checkmark-circle"></ion-icon>
          <img
            [src]="(inputData.landingPage === 'listing-microsite' || inputData.landingPage === undefined) ? '/assets/imgs/listing-microsite.svg' : '/assets/imgs/disabled-listing-microsite.svg'" />
          <span class="standardLabel">Listing Microsite</span>
        </div>
      </div>

      <div class="animation-col">
        <div [ngClass]="inputData.landingPage === 'touch-free-sign-in' ? 'selected-bg' : 'unselected-bg'"
          class="animation-container" (click)="setLandingPage('touch-free-sign-in')"
          data-cy="editLinks-form-type-openhouse">
          <ion-icon *ngIf="inputData.landingPage === 'touch-free-sign-in'" mode="ios"
            name="checkmark-circle"></ion-icon>
          <img
            [src]="inputData.landingPage === 'touch-free-sign-in' ? '/assets/imgs/open-house-icon.svg' : '/assets/imgs/disabled-open-house-icon.svg'" />
          <span class="standardLabel">Open House Sign-in</span>
        </div>
      </div>
    </ion-row>
  </ng-container>
  <!-- 
  <div class="spacer-15"></div>
  
  <div class="borderBox" *ngIf="showTypeSection">
    <ion-item color="none" button="false" class="linkHeaderFeatured fadeIn" lines="none">
      <div (click)="handleTakeoverChange(item, i, $event, false)" slot="start" *ngIf="inputData.fullScreenTakeover === true"
        class="starFilled link listingShareIcons">
        <span>
          <ion-icon class="noTooltip" name="star" slot="icon-only"></ion-icon>
        </span>
      </div>
      <div (click)="handleTakeoverChange(inputData, i, $event, true)" slot="start" *ngIf="!inputData.fullScreenTakeover"
        class="starOutline fadedIcon link listingShareIcons">
        <span>
          <ion-icon class="noTooltip" name="star-outline" slot="icon-only"></ion-icon>
        </span>
      </div>
    
      <label>Make Listing the Full Screen Takeover</label>
      <ion-icon color="primary" class="info-icon" tappable ios="information-circle-sharp" md="information-circle-sharp"
        (click)="checkVCard()">
      </ion-icon>
    </ion-item>
  </div> -->

  <div class="padding" (click)="deleteLink();">
    <ion-button [disabled]="inputData.type === 'vCard'" class="margin-left-20" *ngIf="editLink === true" ion-button>
      Delete</ion-button>
  </div>

  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>